import {cva} from 'class-variance-authority';

export const toggleVariants = cva(
  'inline-flex select-none items-center justify-center rounded-md text-sm font-medium transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--toggle-focus-ring)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'border border-[var(--toggle-border)] bg-[var(--toggle-bg)] font-semibold text-[var(--toggle-text)] hover:border-[var(--toggle-hover-border)] data-[state=on]:border-[var(--toggle-active-border)] data-[state=on]:bg-[var(--toggle-active-bg)] data-[state=on]:text-[var(--toggle-active-text)]',
        tab: 'border border-transparent bg-transparent font-medium text-[var(--toggle-text)] hover:bg-[var(--toggle-hover-bg)] hover:text-[var(--toggle-hover-text)] hover:opacity-35 data-[state=on]:cursor-default data-[state=on]:border-[var(--toggle-active-border)] data-[state=on]:bg-[var(--toggle-tab-active-bg)] data-[state=on]:font-semibold data-[state=on]:text-[var(--toggle-tab-active-text)] data-[state=on]:shadow-[0px_3px_4px_0px_rgba(1,2,3,0.10)] data-[state=on]:hover:opacity-100',
      },
      size: {
        default: 'h-12 min-w-[117px] px-4 text-[15px]',
        sm: 'h-9 min-w-[80px] px-3 text-sm',
        lg: 'h-14 min-w-[140px] px-6 text-base',
        tab: 'h-9 min-w-0 px-[21px] text-[15px]',
      },
      theme: {
        default: '',
        'sky-blue':
          'data-[state=on]:bg-[var(--toggle-sky-blue-active-bg)] data-[state=off]:hover:border-transparent data-[state=off]:hover:bg-[var(--toggle-sky-blue-hover-bg)]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      theme: 'default',
    },
  },
);
